import { File } from './../../models/files/files.model';

export class Slide {
    id?: string;
    claim?: any;
    subclaim?: any;
    text?: any;
    has_button?: any;
    url?: any;
    url_label?: any;
    file?: File;

    constructor(options: any) {
        this.id = options.id;
        this.claim = options.claim;
        this.subclaim = options.subclaim;
        this.text = options.text;
        this.has_button = options.has_button;
        this.url = options.url;
        this.url_label = options.url_label;
        this.file = options.file;
    }
}
